
import { Grid, List } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface ViewToggleProps {
  displayMode: 'grid' | 'list';
  setDisplayMode: (mode: 'grid' | 'list') => void;
}

const ViewToggle = ({ displayMode, setDisplayMode }: ViewToggleProps) => {
  return (
    <div className="flex items-center gap-1 p-1 bg-gray-50 rounded-md border border-gray-100">
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "p-1.5 h-auto w-8", 
          displayMode === 'grid' 
            ? "bg-white text-propertylk-blue shadow-sm border border-gray-200" 
            : "text-gray-500 hover:text-propertylk-blue hover:bg-white/50"
        )}
        onClick={() => setDisplayMode('grid')}
        aria-label="Grid view"
      >
        <Grid className="w-4 h-4" />
      </Button>
      <Button
        variant="ghost"
        size="sm"
        className={cn(
          "p-1.5 h-auto w-8", 
          displayMode === 'list' 
            ? "bg-white text-propertylk-blue shadow-sm border border-gray-200" 
            : "text-gray-500 hover:text-propertylk-blue hover:bg-white/50"
        )}
        onClick={() => setDisplayMode('list')}
        aria-label="List view"
      >
        <List className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default ViewToggle;
